import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalSize } from '@/components';
import { Button } from '@/ui';
import { StyledBody, StyledFooter, StyledMessage } from './RejectFaqModalStyles';

type TRejectFaqModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onReject: () => void;
  isLoading?: boolean;
};

const RejectFaqModal: FC<TRejectFaqModalProps> = ({ isOpen, onClose, onReject, isLoading }) => {
  const { t } = useTranslation();

  return (
    <Modal
      destroyOnClose
      title={t('reject_suggested_faq_title')}
      onCancel={onClose}
      visible={isOpen}
      size={ModalSize.MEDIUM}
    >
      <StyledBody>
        <StyledMessage>{t('reject_suggested_faq_confirm')}</StyledMessage>
        <StyledFooter>
          <Button type="default" onClick={onClose} disabled={isLoading}>
            {t('cancel_btn')}
          </Button>
          <Button type="primary" danger onClick={onReject} loading={isLoading}>
            {t('btn_deny')}
          </Button>
        </StyledFooter>
      </StyledBody>
    </Modal>
  );
};

export default RejectFaqModal;
